import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { collection, deleteDoc, doc, onSnapshot, query, serverTimestamp, setDoc, where } from "firebase/firestore";
import { auth, db } from "../firebase";
import { getNextEventDate } from "../routes/eventsUtils";

// "Seguir publicación": oferta, evento, auto o propiedad. Cada seguimiento es
// itemFollows/{uid}_{type}_{itemId}; los avisos (falta poco, bajó de precio,
// cambió la fecha) los manda functions/itemFollows.js.
export const ITEM_TYPES = ["offer", "event", "car", "place"];

const followId = (uid, type, itemId) => `${uid}_${type}_${itemId}`;

// Una sola suscripción para toda la app, aunque haya un botón por tarjeta.
let followed = new Set();
let listeners = new Set();
let unsubscribeFollows = null;
let currentUid = null;

const emit = () => listeners.forEach((fn) => fn(followed));

const watch = (uid) => {
  if (uid === currentUid) return;
  if (unsubscribeFollows) unsubscribeFollows();
  unsubscribeFollows = null;
  currentUid = uid;
  followed = new Set();
  emit();
  if (!uid) return;
  unsubscribeFollows = onSnapshot(
    query(collection(db, "itemFollows"), where("uid", "==", uid)),
    (snap) => {
      followed = new Set(snap.docs.map((d) => `${d.data().type}_${d.data().itemId}`));
      emit();
    },
    (error) => console.error("Error cargando publicaciones seguidas:", error)
  );
};

onAuthStateChanged(auth, (user) => watch(user?.uid || null));

export const useIsItemFollowed = (type, itemId) => {
  const [set, setSet] = useState(followed);
  useEffect(() => {
    listeners.add(setSet);
    setSet(followed);
    return () => listeners.delete(setSet);
  }, []);
  return set.has(`${type}_${itemId}`);
};

export const toggleItemFollow = async ({ type, itemId, title, isFollowed }) => {
  const uid = auth.currentUser?.uid;
  if (!uid || !ITEM_TYPES.includes(type) || !itemId) return;
  const ref = doc(db, "itemFollows", followId(uid, type, itemId));
  if (isFollowed) {
    await deleteDoc(ref);
  } else {
    await setDoc(ref, {
      uid,
      type,
      itemId,
      title: String(title || "").slice(0, 200),
      createdAt: serverTimestamp(),
    });
  }
};

// Momento que se sigue: inicio de la próxima función del evento o fin del
// cupón de la oferta (cuponExpiresAt es "YYYY-MM-DD", vale todo ese día).
export const getItemDeadline = (type, item, now = new Date()) => {
  if (type === "event") return getNextEventDate(item, now);
  if (type === "offer" && item?.cuponExpiresAt) {
    const end = new Date(`${item.cuponExpiresAt}T23:59:59`);
    return Number.isNaN(end.getTime()) ? null : end;
  }
  return null;
};
